import Box from '@mui/material/Box';
import MDBox from 'components/MDBox';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import MDTypography from 'components/MDTypography';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

// ✅ Styled Accordion Summary
export const StyledAccordionSummary = styled(AccordionSummary)({
  padding: 0,
  minHeight: 48,

  '&.Mui-expanded': {
    minHeight: 48,
  },

  '& .MuiAccordionSummary-content': {
    margin: 0,
    display: 'flex',
    alignItems: 'center',

    '&.Mui-expanded': {
      margin: 0,
    },
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    display: 'flex',
    marginRight: '8px',
    alignItems: 'center',
  },
});

// ✅ Styled Accordion Details
export const StyledAccordionDetails = styled(AccordionDetails)({
  padding: '8px 0px 0px 8px',
});

export const SsaProfileButton = styled(Button)`
  color: #1976d2;
  text-transform: none;
  border-color: #1976d2;

  &:hover {
    border: 1px solid #1565c0;
    background-color: rgba(25, 118, 210, 0.04);
  }
`;

export const SsaPasswordBox = styled(MDBox)`
  display: flex;
  max-width: 400px;
  padding: 16px;
  border-radius: 1;
  align-items: center;
  background-color: #e3f2fd;
  justify-content: space-between;
`;

export const PasswordTypography = styled(MDTypography)`
  ${(props) => (props?.error ? `color: #F44335` : '#1976d2')};
`;

export const SsaEmptyStateBox = styled(MDBox)`
  display: flex;
  padding: 16px;
  border-radius: 1;
  align-items: center;
  background-color: #e3f2fd;
  justify-content: space-between;
`;

export const NotesHistoryTypography = styled(Typography)`
  font-weight: 400;
  font-size: 0.9rem;
  margin-bottom: 8px;
  color: #344767ad;
  white-space: pre-wrap;
`;

// Modern UI Redesign Components

export const ProfileCard = styled(Box)(({ theme }) => ({
  gap: '8px',
  height: '100%',
  padding: '16px',
  display: 'flex',
  borderRadius: '16px',
  flexDirection: 'column',
  backgroundColor: '#fff',
  border: '1px solid #d4d8e8',
  boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.05)',
}));

export const CardHeader = styled(Box)({
  gap: '12px',
  display: 'flex',
  alignItems: 'center',
});

export const HeaderIconWrapper = styled(Box)(({ theme, bgColor }) => ({
  width: '36px',
  height: '36px',
  display: 'flex',
  color: '#4f4f4f',
  borderRadius: '8px',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: bgColor || '#f0f4ff',
}));

export const HeaderTitle = styled(Typography)({
  fontWeight: 700,
  color: '#2c3e50',
  fontSize: '1.1rem',
  fontFamily: '"DM Sans", sans-serif',
});

export const DataFieldContainer = styled(Box)({
  gap: '16px',
  display: 'flex',
  padding: '8px 0',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});

export const FieldLabel = styled(Typography)({
  fontWeight: 600,
  color: '#a0aec0',
  fontSize: '0.75rem',
  letterSpacing: '0.025em',
  textTransform: 'uppercase',
});

export const FieldValue = styled(Typography)({
  maxWidth: '60%',
  fontWeight: 600,
  color: '#2d3748',
  textAlign: 'right',
  fontSize: '0.95rem',
  wordBreak: 'break-word',
});

export const StudentIdPill = styled(Box)({
  fontWeight: 700,
  color: '#5c7cfa',
  padding: '4px 12px',
  fontSize: '0.875rem',
  borderRadius: '20px',
  backgroundColor: '#edf2ff',
  border: '1px solid #dbe4ff',
});

export const ActionButtonsContainer = styled(Box)({
  gap: '12px',
  display: 'flex',
  marginTop: '16px',
});

export const PasswordDisplayBox = styled(Box)({
  gap: '8px',
  display: 'flex',
  marginTop: '16px',
  padding: '12px 16px',
  alignItems: 'center',
  borderRadius: '12px',
  backgroundColor: '#f8fafc',
  border: '1px dashed #e2e8f0',
});

export const NoteCard = styled(ProfileCard)({
  width: '100%',
  marginTop: '24px',
});

export const StyledTextAreaContainer = styled(Box)({
  padding: '16px',
  marginTop: '16px',
  minHeight: '120px',
  borderRadius: '12px',
  backgroundColor: '#f8fafc',
  border: '1px solid #f1f5f9',
});
